import React, { useContext, createContext, useState, useRef, useEffect, useMemo, useCallback } from 'react';
import { ListGroup, Dropdown, Modal, Button, Spinner } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { replaceString } from 'src/api/demo';
import { useCommonContext } from 'src/contexts/CommonContext';
import AccountsReset from './AccountsReset';
import { CustomCountryDropdown } from 'src/components/CountryFlagSelect';
import Search from 'src/components/Form/search';
import { SearchFilter } from 'src/helper/search';
import PerfectScrollbar from 'react-perfect-scrollbar';
import StarIcon from 'src/assets/icons/StarIcon';
import useApi from 'src/hooks/useApi';
import services from 'src/api/service';
import { COUNTRIES } from 'src/config/constant';
import { debounce } from 'lodash';
import { CurrencyCodeMarketPlace } from '../..';
import { getCountryFlagUrl } from 'src/utils/utils';
import DownChevron, { RightChevron } from 'src/assets/icons/DownChevron';
import { PendingDspBrandSelectModal } from 'src/layouts/AdminLayout/NavBar/NavRight';
import useDefaultProfile from 'src/hooks/useDefaultProfile';

export default function AmazonProfiles({ rtlLayout, activeCopyProfiles = [], listTotalCount = 0 }) {

    const ParseData = JSON.parse(localStorage.getItem('User'));
    const isSuperAdmin = String(process.env.REACT_APP_ADMIN_ACCESS_EMAIL || '').indexOf(ParseData?.email) > -1

    const [showAccDropdown, setShowAccDropdown] = useState(false);
    const selectedProfileId = JSON.parse(sessionStorage.getItem('selectedProfileId'));
    const selectedLocalCountry = useMemo(() => {
        return JSON.parse(localStorage.getItem('selectedCountry')) || COUNTRIES?.[0]
    }, []);
    const [valueSearch, setValueSearch] = useState('');
    const [apiSearch, setApiSearch] = useState('');

    const [defaultActive, setDefaultActive] = useState([selectedProfileId]);
    const { commonState, commonDispatch } = useCommonContext()
    const [countrySelected, setCountrySelected] = useState(selectedLocalCountry ? selectedLocalCountry : COUNTRIES?.[0]);
    const [showDspBrandSelectModal, setShowDspBrandSelectModal] = useState(false);

    const amsDefaultActiveProfiles = useMemo(() => {
        return [...activeCopyProfiles]
    }, [activeCopyProfiles])

    const [activeProfilesAMS, setAMSactiveProfiles] = useState({ data: [...amsDefaultActiveProfiles], filteredData: [] });
    const [activeProfilesDSP, setDSPactiveProfiles] = useState({ data: [], filteredData: [] });
    const [activeProfilesAgency, setAgencyActiveProfiles] = useState({ data: [], filteredData: [] });
    const [agencyBrands, setAgencyBrands] = useState({});
    const [expandedAgency, setExpandedAgency] = useState(null);

    const [dspActiveProfiles, setDspActiveProfiles] = useState([]);
    const [tabKey, setTabKey] = useState(window.location.pathname.indexOf('dsp') > -1 ? 'dsp' : 'ams');

    const [amsPageQuery, setAmsPageQuery] = useState({ page: 1, limit: 20, total_count: listTotalCount, searchTerm: '' });
    const [dspPageQuery, setDspPageQuery] = useState({ page: 1, limit: 20, total_count: 0, searchTerm: '' });
    const [agencyPageQuery, setAgencyPageQuery] = useState({ page: 1, limit: 20, total_count: 0, searchTerm: '' });
    
    const amsGetProfiles = useApi(services.postService)
    const dspGetProfiles = useApi(services.postService)
    const agencyGetProfiles = useApi(services.postService)
    const agencyGetBrands = useApi(services.postService)

    const setAccDropdown = () => {
        setShowAccDropdown(!showAccDropdown);
        console.log({ selectedProfileId, showAccDropdown });
        if (!showAccDropdown) {
            console.log({ selectedProfileId, showAccDropdown });
            setCountrySelected({ code: selectedProfileId.countryCode, country_code: selectedProfileId.countryCode });
        }
    };

    const handleSelectCountry = (country) => {
        console.log("handleSelectCountry", country)
        setAmsPageQuery((prev) => ({...prev, page: 1, total_count: 0}))
        setCountrySelected(country);
        localStorage.setItem('selectedCountry', JSON.stringify(country));
    };

    const searchInputHandle = async (e) => {
        const keyword = typeof e === 'string' ? e : e.target.value;
        console.log('keyword', keyword);
        const { data, filteredData } = await SearchFilter(activeCopyProfiles, keyword);

        if (keyword !== '') {
            setAMSactiveProfiles({ data, filteredData });
        } else {
            setAMSactiveProfiles({ data, filteredData });
        }
        setValueSearch(keyword);
    };

    const { removeDefaultProfile } = useDefaultProfile();

    const handleSelect = async (selectedItem) => {
        setDefaultActive([selectedItem]);

        document.getElementById('fullPageLoader').style.visibility = 'visible';

        // if(selectedItem && Object.keys(selectedItem).length > 0 && selectedItem?.profileId && window.location.href.indexOf('/amazon/targeting') > -1) {
        //     removeDefaultProfile(selectedItem);
        // }
        
        sessionStorage.setItem('selectedProfileId', JSON.stringify(selectedItem));
        if (selectedItem?.ams?.groupedAccounts?.length > 0) {
            sessionStorage.setItem('selectedGroupedProfileId', JSON.stringify(selectedItem))
        }
        localStorage.removeItem('brandConfigureIgnore');
        setTimeout(() => {
            if (window.location.href.includes('billing-payments')) {
                window.location.reload();
            } else if (
                selectedItem?.dsp_only === true ||
                (window.location.href.includes('dsp') && selectedItem?.dsp?.length > 0)
              ) {
                const currentPath = window.location.pathname;
              
                const knownDspStaticPaths = new Set([
                  '/amazon-dsp-logs',
                  '/amazon-dsp/marketing-stream',
                  '/amazon-dsp-dayparting-performance',
                  '/amazon-dsp-dayparting-scheduler',
                  '/amazon-dsp-dayparting-history',
                  '/amazon-dsp-dayparting-schedule-log',
                  '/amazon-dsp-smart-campaigns',
                ]);
              
                if (currentPath === '/amazon-dsp-request') {
                  window.location.href = '/amazon-dsp/campaign';
                  return;
                }
              
                // Derive parent path directly from URL path
                let parentPath = null;
                const dspMatch = currentPath.match(/^\/amazon-dsp\/([^/]+)(?:\/|$)/);
                const automatedRuleMatch = currentPath.match(/^\/amazon-dsp-automated-rules\/([^/]+)(?:\/|$)/);
                const daypartingScheduleLogMatch = currentPath.match(/^\/amazon-dsp-dayparting-schedule-log\/([^/]+)(?:\/|$)/);

                if (dspMatch?.[1]) {
                  parentPath = `/amazon-dsp/${dspMatch[1]}`;
                } else if (automatedRuleMatch?.[1]) {
                  parentPath = `/amazon-dsp-automated-rules/${automatedRuleMatch[1]}`;
                } else if (daypartingScheduleLogMatch?.[1]) {
                  parentPath = `/amazon-dsp-dayparting-schedule-log/${daypartingScheduleLogMatch[1]}`;
                }
              
                if (parentPath) {
                  if (currentPath !== parentPath) {
                    window.location.href = parentPath;
                  } else {
                    window.location.reload();
                  }
                } else if (knownDspStaticPaths.has(currentPath)) {
                  window.location.reload();
                } else {
                  window.location.href = '/amazon-dsp/campaign';
                }
              }
              
               else if (window.location.href.indexOf('plan-expired') > -1) {
                window.location.href = '/amazon/targeting';
            } else if(selectedItem.ams?.connected == false) {
                window.location.href = '/amazon-audience-report';
            } else {
                window.location.reload();
            }
        }, 1000);
        setShowAccDropdown(!showAccDropdown);
    };

    useEffect(() => {
        if (showAccDropdown) {
          document.body.classList.add('overflow-hidden');
        } else {
          document.body.classList.remove('overflow-hidden');
        }
      }, [showAccDropdown]);
    

    const listProfiles = useMemo(() => {
        
        if(tabKey == 'ams') {
            if (isSuperAdmin) {
                const defaultProfiles = activeProfilesAMS?.data?.filter((dataItem) => dataItem.profileId == selectedProfileId?.profileId);
                const nonDefaultProfiles = activeProfilesAMS?.data?.filter((dataItem) => dataItem.profileId != selectedProfileId?.profileId);
                return [...defaultProfiles, ...nonDefaultProfiles];
            }
            if (valueSearch !== '') {
                const defaultProfiles = activeProfilesAMS?.filteredData?.filter((dataItem) => dataItem.profileId == selectedProfileId?.profileId);
                const nonDefaultProfiles = activeProfilesAMS?.filteredData?.filter((dataItem) => dataItem.profileId != selectedProfileId?.profileId);
                return [...defaultProfiles, ...nonDefaultProfiles];
            } else {
                const defaultProfiles = activeProfilesAMS?.data?.filter((dataItem) => dataItem.profileId == selectedProfileId?.profileId);
                const nonDefaultProfiles = activeProfilesAMS?.data?.filter((dataItem) => dataItem.profileId != selectedProfileId?.profileId);
                return [...defaultProfiles, ...nonDefaultProfiles];
            }
        }

        if(tabKey == 'dsp') {
            if (isSuperAdmin) {
                const defaultProfiles = activeProfilesDSP?.data?.filter((dataItem) => dataItem.profileId == selectedProfileId?.profileId);
                const nonDefaultProfiles = activeProfilesDSP?.data?.filter((dataItem) => dataItem.profileId != selectedProfileId?.profileId);
                return [...defaultProfiles, ...nonDefaultProfiles];
            }
            if (valueSearch !== '') {
                const defaultProfiles = activeProfilesDSP?.filteredData?.filter((dataItem) => dataItem.dspId == selectedProfileId?.dspId);
                const nonDefaultProfiles = activeProfilesDSP?.filteredData?.filter((dataItem) => dataItem.dspId != selectedProfileId?.dspId);
                return [...defaultProfiles, ...nonDefaultProfiles];
            } else {
                const defaultProfiles = activeProfilesDSP?.data?.filter((dataItem) => dataItem.dspId == selectedProfileId?.dspId);
                const nonDefaultProfiles = activeProfilesDSP?.data?.filter((dataItem) => dataItem.dspId != selectedProfileId?.dspId);
                return [...defaultProfiles, ...nonDefaultProfiles];
            }
        }

        if(tabKey == 'agency') {
            if (isSuperAdmin) {
                return activeProfilesAgency?.data || [];
            }
            if (valueSearch !== '') {
                return activeProfilesAgency?.filteredData || [];
            } else {
                return activeProfilesAgency?.data || [];
            }
        }

        return []

    }, [activeProfilesAMS, activeProfilesDSP, activeProfilesAgency, tabKey, valueSearch])

    const doOnScrollRef = useRef();

    useEffect(() => {
        if (isSuperAdmin && tabKey == 'ams') {
            console.log("countrySelected", {countrySelected});
            
            amsGetProfiles.request({
                url: '/profiles/mdb-get-ams-profiles',
                payload: {
                    active: true,
                    page: amsPageQuery?.page,
                    limit: amsPageQuery?.limit,
                    ...(amsPageQuery?.searchTerm && { searchTerm: amsPageQuery?.searchTerm }),
                    ...(countrySelected?.country_code && { countryCode: countrySelected?.country_code }),
                }
            })
        }
    }, [tabKey, amsPageQuery?.page, amsPageQuery?.searchTerm, countrySelected?.country_code])

    useEffect(() => {
        if (isSuperAdmin && tabKey == 'dsp') {
            dspGetProfiles.request({
                url: '/profiles/mdb-get-dsp-profiles',
                payload: {
                    page: dspPageQuery?.page,
                    limit: dspPageQuery?.limit,
                    ...(dspPageQuery?.searchTerm && { searchTerm: dspPageQuery?.searchTerm }),
                    ...(countrySelected?.country_code && { countryCode: countrySelected?.country_code }),
                }
            })
        }
    }, [tabKey, dspPageQuery?.page, dspPageQuery?.searchTerm, countrySelected?.country_code])

    // Load agency data when tab changes to agency
    useEffect(() => {
        if (isSuperAdmin && tabKey == 'agency') {
            agencyGetProfiles.request({
                url: '/profiles/mdb-get-agency-profiles',
                payload: {
                    page: agencyPageQuery?.page,
                    limit: agencyPageQuery?.limit,
                    ...(agencyPageQuery?.searchTerm && { searchTerm: agencyPageQuery?.searchTerm }),
                    ...(countrySelected?.country_code && { countryCode: countrySelected?.country_code }),
                }
            })
        }
    }, [tabKey, agencyPageQuery?.page, agencyPageQuery?.searchTerm, countrySelected?.country_code])

    // Update toggle agency expansion to fetch brands
    const toggleAgencyExpansion = (agencyId) => {
        setExpandedAgency(expandedAgency === agencyId ? null : agencyId);
    };

    // Function to handle agency brand selection
    const handleBrandSelect = (brand) => {
        if(brand?.isDspPendingRequest) {
            handleDspBrandSelect();
        } else {
            handleSelect(brand);
        }
    };

    // Function to handle selection of DSP brand which is not active yet
    const handleDspBrandSelect = () => {
        setShowDspBrandSelectModal(true);
    };

    const useRowItem = useCallback((profiles, selectedCountry) => {
        if(tabKey === 'ams') {
            return profiles?.map((rowItem) => ({
                ...rowItem,
                countryCode: rowItem?.countryCode || 'IN',
                currencyCode: rowItem?.currencyCode || 'INR',
                timezone: rowItem?.timezone || 'Asia/Kolkata',
                profileId: rowItem.profileId,
                accessLevel: rowItem.accessLevel || 'Admin',
                profileOwner: rowItem.profileOwner || ParseData?.email,
                accountInfo: {
                  type: 'advertising',
                  ...rowItem?.accountInfo,
                  name: rowItem?.accountInfo?.name || rowItem.Lable,
                }
            }))
        } else if(tabKey == 'dsp') {
            return profiles?.map((dspItem)=>({
                ...dspItem,
                amazonManaged:dspItem?.amazonManaged,
                countryCode: dspItem?.countryCode || 'IN',
                currencyCode: dspItem?.currencyCode || 'INR',
                timezone: dspItem?.timezone || 'Asia/Kolkata',
                dspClientName: dspItem.dspClientName,
                dspBrandName: dspItem.dspBrandName,
                accountInfo:{
                    id: dspItem.dspId,
                    name: dspItem.dspBrandName || dspItem.dspClientName,
                    type:'DSP'
                },
                datasetId: dspItem.dspdatasetId,
                displayTypeTitle: 'DSP',
                profileOwner:dspItem.clientEmail,
                accessLevel: dspItem?.accessLevel || 'Admin',
                profileId: dspItem?.agencyProfileId,
                dsp_only: true,
                marketplace: `${CurrencyCodeMarketPlace[dspItem?.currencyCode || 'INR'] || 'europe'}`,
                dsp: [dspItem, ...(dspItem?.newDsp ?? [])]
            }))
        } else if(tabKey == 'agency') {
            return profiles?.map((agencyItem) => ({
                ...agencyItem,
                countryCode: selectedCountry,
                id: agencyItem?.id ?? agencyItem?.agencyName?.replace(' ', '').toLowerCase(),
                accountInfo: {
                    type: 'agency',
                    name: agencyItem.agencyName,
                    id: agencyItem.id
                }
            }))
        }

        return profiles
    }, [tabKey])

    useEffect(() => {
        const { loading, data } = amsGetProfiles
        if(!loading && data && data?.success == true) {
            const listData = data?.data?.result || data?.data || []
            const modifiedProfiles = useRowItem(listData)
            const listDataCount = data?.data?.totalCount || data?.data?.length || 0
            setAMSactiveProfiles((prev) => ({
                ...prev,
                data: amsPageQuery?.page == 1 ? [...modifiedProfiles] : [...prev?.data, ...modifiedProfiles],
            }))
            amsGetProfiles.clear()
            setAmsPageQuery((prev) => ({...prev, total_count: listDataCount}))
        }
    }, [amsGetProfiles.loading, amsPageQuery?.page])

    useEffect(() => {
        const { loading, data } = agencyGetProfiles
        if(!loading && data && data?.success == true && data?.data) {
            const listData = data?.data?.result || [];
            const modifiedProfiles = useRowItem(listData, countrySelected?.country_code);
            const listDataCount = data?.data?.totalCount || 0
            setAgencyActiveProfiles((prev) => ({
                ...prev,
                data: agencyPageQuery.page == 1 ? [...modifiedProfiles] : [...prev?.data, ...modifiedProfiles],
            }))

            const brandsMap = {};
            modifiedProfiles.forEach(agency => {
                const profileBrands = (agency.profiles || []).map(brand => ({
                    ...brand,
                    name: brand?.accountInfo?.name,
                    type: 'brand'
                }));

                const dspBrands = (agency.dspAccounts || []).map(brand => ({
                    ...brand,
                    name: brand?.dspBrandName || brand?.dspClientName,
                    type: 'brand',
                    dsp: [brand, ...(brand?.newDsp ?? [])],
                    dsp_only: true,
                    profileId: brand?.agencyProfileId,
                    countryCode: brand?.countryCode || 'IN',
                    currencyCode: brand?.currencyCode || 'INR',
                    timezone: brand?.timezone || 'Asia/Kolkata',
                    accountInfo:{
                        id: brand.dspId,
                        name: brand.dspClientName,
                        type:'DSP'
                    },
                    datasetId: brand.dspdatasetId,
                    displayTypeTitle: 'DSP',
                    profileOwner: brand?.clientEmail,
                    accessLevel: brand?.accessLevel || 'Admin',
                    marketplace: `${CurrencyCodeMarketPlace[brand?.currencyCode || 'INR'] || 'europe'}`,
                }));

                const pendingDspBrands = (agency.dspPendingRequests || []).map(brand => ({
                    ...brand,
                    name: brand?.dspClientName,
                    type: 'brand',
                    dsp: [brand],
                    dsp_only: true,
                    countryCode: brand?.countryCode || 'IN',
                    currencyCode: brand?.currencyCode || 'INR',
                    timezone: brand?.timezone || 'Asia/Kolkata',
                    accessLevel: brand?.accessLevel || 'Admin',
                    profileOwner: brand?.clientEmail,
                    displayTypeTitle: 'DSP',
                    isDspPendingRequest: true,
                    accountInfo:{
                        name: brand?.dspClientName,
                        type:'DSP'
                    },
                }));
                
                brandsMap[agency?.id] = [...profileBrands, ...dspBrands, ...pendingDspBrands];
            });
            setAgencyBrands(brandsMap);
            agencyGetProfiles.clear()
            setAgencyPageQuery((prev) => ({...prev, total_count: listDataCount}))
        }
    }, [agencyGetProfiles.loading, agencyPageQuery.page])


    useEffect(() => {
        const { loading, data } = dspGetProfiles
        if(!loading && data && data?.success == true && data?.data) {
            const listData = data?.data?.result || data?.data || []
            const modifiedProfiles = useRowItem(listData)
            const listDataCount = data?.data?.totalCount || data?.data?.length || 0
            setDSPactiveProfiles((prev) => ({
                ...prev,
                data: dspPageQuery.page == 1 ? [...modifiedProfiles] : [...prev?.data, ...modifiedProfiles],
            }))
            dspGetProfiles.clear()
            setDspPageQuery((prev) => ({...prev, total_count: listDataCount}))
        }
    }, [dspGetProfiles.loading, dspPageQuery.page])


    const handleScroll = useCallback((container) => {

        const { loading: loadingAMS } = amsGetProfiles;
        const { loading: loadingDSP } = dspGetProfiles;
        const { loading: loadingAgency } = agencyGetProfiles;

        if (!doOnScrollRef.current) return;

        console.log("handleScrollQuery", 
            {
                amsPageQueryCount: amsPageQuery?.total_count,
                dspPageQueryCount: dspPageQuery?.total_count,
                agencyPageQueryCount: agencyPageQuery?.total_count,
                listCount: listProfiles?.length,
                // scrollRef: doOnScrollRef.current,
            }
        )
    
        if(tabKey == 'ams' && !loadingAMS) {
            if (doOnScrollRef.current && amsPageQuery?.total_count > listProfiles?.length && !loadingAMS && !loadingDSP) {
                const { scrollTop, scrollHeight, clientHeight } = container;
                const diffHeight = Math.abs(scrollTop + clientHeight - scrollHeight);
                console.log("handleScroll", {check1: scrollTop + clientHeight >= scrollHeight, check2: diffHeight <= 1});
                if (scrollTop + clientHeight >= scrollHeight  || diffHeight <= 1) {
                    setAmsPageQuery((prev) => ({...prev, page: prev.page + 1}))
                }
            }
        } else if(tabKey == 'dsp' && !loadingDSP) {
            if (doOnScrollRef.current && dspPageQuery?.total_count > listProfiles?.length && !loadingAMS && !loadingDSP) {
                const { scrollTop, scrollHeight, clientHeight } = container;
                const diffHeight = Math.abs(scrollTop + clientHeight - scrollHeight);
                console.log("handleScroll", {check1: scrollTop + clientHeight >= scrollHeight, check2: diffHeight <= 1});
                if (scrollTop + clientHeight >= scrollHeight || diffHeight <= 1) {
                    setDspPageQuery((prev) => ({...prev, page: prev.page + 1}))
                }
            }
        } else if(tabKey == 'agency' && !loadingAgency) {
            if (doOnScrollRef.current && agencyPageQuery?.total_count > listProfiles?.length && !loadingAgency) {
                const { scrollTop, scrollHeight, clientHeight } = container;
                const diffHeight = Math.abs(scrollTop + clientHeight - scrollHeight);
                if (scrollTop + clientHeight >= scrollHeight || diffHeight <= 1) {
                    setAgencyPageQuery((prev) => ({...prev, page: prev.page + 1}))
                }
            }
        }

    }, [tabKey, amsGetProfiles.loading, dspGetProfiles.loading, agencyGetProfiles.loading, amsPageQuery?.page, amsPageQuery?.limit, amsPageQuery?.total_count, dspPageQuery?.page, dspPageQuery?.limit, dspPageQuery?.total_count, agencyPageQuery?.page, agencyPageQuery?.limit, agencyPageQuery?.total_count, listProfiles?.length])


    const debouncedSetListQuery = useCallback(
        debounce((newQuery) => {
            if(tabKey == 'ams') {
                setAmsPageQuery(newQuery);
            } else if(tabKey == 'dsp') {
                setDspPageQuery(newQuery);
            } else if(tabKey == 'agency') {
                setAgencyPageQuery(newQuery);
            }
        }, 500),
        [tabKey]
      );
    
      const apiSearchInputHandle = (e) => {
        const value = typeof e === 'string' ? e : e.target.value;
        setApiSearch(value);
        debouncedSetListQuery((prev) => ({
          ...prev,
          searchTerm: value,
          page: 1
        }));
      };

      useEffect(() => {
        if (tabKey === 'ams' || tabKey === 'dsp' || tabKey === 'agency') {
          if (isSuperAdmin) {
            apiSearchInputHandle(''); 
          } else {
            searchInputHandle(''); 
          }
        }
      }, [tabKey]); 

    return (
        <React.Fragment>
            <ListGroup.Item as="li" bsPrefix=" " className="nav_acc_slct ch_toggle country-select-responsive">
                <Dropdown alignRight={!rtlLayout} className="select-account" show={showAccDropdown} onToggle={setAccDropdown}>

                    <Dropdown.Toggle as="li" id="dropdown-basic" onClick={setAccDropdown} className="cursor-pointer">
                        <div className="text-right d-flex flex-column l-base align-items-end pr-2 drop-crd">
                            <div className="f-w-600 f-14 d-flex align-items-center text-left">
                                <img
                                    src={getCountryFlagUrl(defaultActive?.map((select) => select?.countryCode?.toLowerCase()))}
                                    alt=""
                                    className="country_flag_drop"
                                />
                                <div className="d-flex flex-column f-10 f-333843">
                                    {defaultActive?.map((select) => replaceString(select?.profileId === 3263660519271617 ? select?.dsp?.length > 0 ? select?.dsp[0]?.dspClientName : 'PRINTODELIVERY' : select?.accountInfo?.name))}
                                    {defaultActive?.map((select, index) =>
                                        select.accessLevel ? (
                                            <span className="f-10 text-left w-100 f-w-500 spld-bder f-8F8F91" key={index}>
                                                Role: <b className="f-w-600 f-10 f-333843">{select.accessLevel}</b>
                                            </span>
                                        ) : (
                                            <span className="f-10 text-left w-100 f-w-500 spld-bder" key={index}>
                                                Role: <b className="f-w-600 f-10">Admin</b>
                                            </span>
                                        )
                                    )}
                                </div>
                            </div>
                            {/* <small className="f-10 bg-blur px-2 py-1 rounded-10 txt-theme">{defaultActive?.map((select) => select?.countryCode)}</small> */}
                        </div>
                    </Dropdown.Toggle>

                    <Dropdown.Menu alignRight className="themebg notification notification-scroll">
                        {showAccDropdown && <>
                        <div className="noti-head">
                            <div className="countrySelection">
                                {isSuperAdmin ? null : <AccountsReset />}
                                {showAccDropdown && countrySelected?.code ? (
                                    <CustomCountryDropdown className="nav-item" onSelect={handleSelectCountry} countryCode={countrySelected?.code} />
                                ) : null}
                            </div>
                        </div>

                        {(amsGetProfiles.loading || dspGetProfiles.loading || agencyGetProfiles.loading) && (
                            <div 
                                className="position-absolute w-100 h-100 d-flex align-items-center justify-content-center"
                                style={{
                                    backgroundColor: 'rgba(255, 255, 255, 0.8)',
                                    zIndex: 1000,
                                }}
                            >
                                <Spinner animation="border" variant="primary" />
                            </div>
                        )}

                        {isSuperAdmin && (
                            <div className="ams-tabset">
                                <button 
                                    onClick={() => {
                                        setTabKey('ams');
                                        setAmsPageQuery((prev) => ({ ...prev, page: 1, total_count: 0 }));
                                        apiSearchInputHandle('');
                                    }} 
                                    className={`ams-tab-button ${tabKey === 'ams' ? 'active' : ''}`}
                                >
                                    AMS
                                </button>
                                <button 
                                    onClick={() => {
                                    setTabKey('dsp');
                                        setDspPageQuery((prev) => ({ ...prev, page: 1, total_count: 0 }));
                                        apiSearchInputHandle('');
                                    }} 
                                    className={`ams-tab-button ${tabKey === 'dsp' ? 'active' : ''}`}
                                >
                                    DSP
                                </button>
                                {isSuperAdmin && (
                                    <button 
                                        onClick={() => {
                                        setTabKey('agency');
                                            setAgencyPageQuery((prev) => ({ ...prev, page: 1, total_count: 0 }));
                                            apiSearchInputHandle('');
                                        }} 
                                        className={`ams-tab-button ${tabKey === 'agency' ? 'active' : ''}`}
                                    >
                                        Agency
                                    </button>
                                )}
                            </div>
                        )}

                        {/* <p className='text-right'>{tabKey == 'ams' ? `AMS - (${listProfiles.length}/${amsPageQuery?.total_count})` : tabKey == 'dsp' ? `DSP - (${listProfiles.length}/${dspPageQuery?.total_count})` : ''}</p> */}

                        <div className="px-3 pt-1 pb-1">
                        {isSuperAdmin ? (
                            <Search searchValue={apiSearch} callBack={apiSearchInputHandle} />
                               ) : (
                             <Search searchValue={valueSearch} callBack={searchInputHandle} />
                            )}
                        </div>


                        <PerfectScrollbar className="min-hight-150 max-height-300" ref={doOnScrollRef} onScrollY={isSuperAdmin ? handleScroll : () => {}}>
                            <ListGroup as="ul" bsPrefix=" " variant="flush" className="noti-body">
                                {(listProfiles?.filter((rows) => rows.countryCode?.toLowerCase() == countrySelected?.country_code?.toLowerCase())?.length > 0 &&
                                    listProfiles
                                        ?.filter((rows) => rows?.countryCode?.toLowerCase() == countrySelected?.code?.toLowerCase())
                                        ?.map((AMSprofiles, index) => (
                                            <ListGroup.Item
                                                as="li"
                                                bsPrefix=" "
                                                className={'n-title px-0 pt-2'}
                                                key={index}
                                                onClick={() => {
                                                    // For agency items, toggle expansion instead of direct selection
                                                    if (AMSprofiles.accountInfo.type === 'agency' && tabKey === 'agency') {
                                                        toggleAgencyExpansion(AMSprofiles?.id);
                                                    } else {
                                                        handleSelect(AMSprofiles);
                                                    }
                                                }}
                                            >
                                                <div
                                                    className={`dropdown-item d-flex align-items-center justify-content-between ${defaultActive?.[0]?.profileId === AMSprofiles.profileId && defaultActive?.[0]?.profileId === AMSprofiles.profileId && defaultActive?.[0]?.accountInfo?.type === AMSprofiles?.accountInfo?.type ? 'active' : ''
                                                        }`}
                                                >
                                                    <section className="d-flex align-items-center">
                                                        <img
                                                            src={getCountryFlagUrl(AMSprofiles?.countryCode)}
                                                            alt=""
                                                            className="wid-30 hei-25 mr-4"
                                                        />

                                                        <div title={replaceString(AMSprofiles?.accountInfo?.name)}>
                                                            <h4 className="mb-2 f-w-600 f-14 d-flex align-items-center">
                                                                {' '}
                                                                <span className="profile-name-truncate">{replaceString(AMSprofiles?.profileId === 3263660519271617 ? AMSprofiles?.dsp?.length > 0 ? AMSprofiles?.dsp[0]?.dspClientName : 'PRINTODELIVERY' : AMSprofiles?.accountInfo?.name)} </span>
                                                                <p
                                                                    className={`f-w-500 f-14 ml-2 mb-0 d-flex align-items-center ${AMSprofiles.accountInfo.type === 'seller'
                                                                        ? 'txt-theme'
                                                                        : AMSprofiles.accountInfo.type === 'DSP'
                                                                            ? 'text-dsp'
                                                                            : AMSprofiles.accountInfo.type === 'agency'
                                                                                ? 'text-primary'
                                                                                : 'text-success'
                                                                        }`}
                                                                >
                                                                    ({AMSprofiles.accountInfo.type})
                                                                    {AMSprofiles.accountInfo.type === 'DSP' && (
                                                                        <span className="ml-1">
                                                                            <StarIcon fillColor={'#FFBD40'} />
                                                                        </span>
                                                                    )}
                                                                    {tabKey === 'agency' && AMSprofiles.accountInfo.type === 'agency' && (
                                                                        <span className="ml-2">
                                                                            {expandedAgency === AMSprofiles.id ? <DownChevron width="12" height="12" color="#ced4da" /> :  <RightChevron width="12" height="12" stroke="#ced4da" />                                                                            }
                                                                        </span>
                                                                    )}
                                                                </p>
                                                            </h4>

                                                            {AMSprofiles.accessLevel ? (
                                                                <p className="f-13 mb-0 f-w-500">
                                                                    Role: &nbsp; <b className="f-w-600 pr-1">{AMSprofiles.accessLevel}</b> |{' '}
                                                                    <a
                                                                        className="cursor-pointer profile_link f-12 pl-1"
                                                                    >
                                                                        {AMSprofiles.accountInfo.id}
                                                                    </a>
                                                                    {/* <small className="">{(AMSprofiles?.seat === "neon")  ? `| (New)` : (AMSprofiles?.seat === "mixshift") ? `| (Old)` : ''}</small> */}
                                                                </p>
                                                            ) : (
                                                                ''
                                                            )}
                                                            {process.env.REACT_APP_ADMIN_ACCESS_EMAIL.indexOf(commonState?.userInfo?.email) > -1 &&
                                                                (('clientEmail' in AMSprofiles &&
                                                                    AMSprofiles.clientEmail != null &&
                                                                    AMSprofiles.clientEmail != '' &&
                                                                    AMSprofiles.clientEmail != commonState?.userInfo?.email) ||
                                                                    ('client_email' in AMSprofiles &&
                                                                        AMSprofiles.client_email != null &&
                                                                        AMSprofiles.client_email != '' &&
                                                                        AMSprofiles.client_email != commonState?.userInfo?.email)) ? (
                                                            <p
                                                                className="f-13 mb-0 f-w-500 profile-truncate d-flex align-items-center"
                                                                title={AMSprofiles.clientEmail ? AMSprofiles.clientEmail : AMSprofiles.client_email}
                                                            >
                                                                Owned By:{' '}
                                                                <b className="f-w-600 pr-1 mx-1">
                                                                    {AMSprofiles.clientEmail ? AMSprofiles.clientEmail : AMSprofiles.client_email}
                                                                </b>
                                                            </p>
                                                        ) : (
                                                            ''
                                                        )}
                                                        {/* <p className="f-13 mb-0 f-w-500">{AMSprofiles.profileId}</p> */}
                                                        {/* <p className="f-12 text-secondary f-w-500 d-flex align-items-center"> */}
                                                    </div>
                                                </section>
                                            </div>
                                            
                                            {/* Render brands if agency is expanded */}
                                            {AMSprofiles.accountInfo.type === 'agency' && expandedAgency === AMSprofiles.id && agencyBrands[AMSprofiles?.id] && (
                                                <div className="agency-brands-container ml-4 pl-4 border-left">
                                                    {agencyBrands[AMSprofiles.id].map((brand, brandIndex) => (
                                                        <div 
                                                            key={brandIndex} 
                                                            className="dropdown-item d-flex align-items-center py-2 cursor-pointer"
                                                            onClick={(e) => {
                                                                e.stopPropagation();
                                                                handleBrandSelect(brand);
                                                            }}
                                                        >
                                                            <img
                                                                src={getCountryFlagUrl(brand.countryCode)}
                                                                alt=""
                                                                className="wid-20 hei-15 mr-2"
                                                            />
                                                            <div>
                                                                <h5 className="mb-0 f-w-500 f-13">{brand.name}</h5>
                                                                <small className="text-muted f-11">(Brand)</small>
                                                                {/* <small className="text-muted f-11">{(brand?.seat === "neon")  ? `(New)` : (brand?.seat === "mixshift") ? `(Old)` : ''}</small> */}
                                                            </div>
                                                        </div>
                                                    ))}
                                                </div>
                                            )}
                                        </ListGroup.Item>
                                    ))) ||
                                (!dspGetProfiles.loading && !amsGetProfiles.loading && !agencyGetProfiles.loading && listProfiles?.filter((rows) => rows?.countryCode?.toLowerCase() == countrySelected?.code?.toLowerCase())?.length === 0 && (
                                    <div className="hei-300 w-100 d-flex align-items-center justify-content-center f-w-700 txt-danger">
                                        No Profiles Found
                                    </div>
                                ))}
                            </ListGroup>
                        </PerfectScrollbar>
                        
                        
                        <div className="noti-footer py-2 text-left">
                            <Link to="/profile" className="mb-1">
                                Manage Your Accounts
                            </Link>
                            <br />
                            <Link to="/addaccount">Add a new account</Link>
                        </div>
                         </>}
                    </Dropdown.Menu>
                </Dropdown>
            </ListGroup.Item>

            <PendingDspBrandSelectModal show={showDspBrandSelectModal} onHide={() => setShowDspBrandSelectModal(false)} />
        </React.Fragment>
    )
}